import { calculateMetFor } from 'utils';

export const WorkoutCaloriesBurnt = {
  bindings: {
    member: '<',
    met: '<',
    totalTime: '<',
  },

  template: `{{ $ctrl.caloriesBurnt | number: 0 }}`,

  controller() {
    'ngInject';

    return {
      $onChanges() {
        if (this.member && this.met && this.totalTime) {
          this.caloriesBurnt = calculateMetFor(
            this.member,
            this.met,
            this.totalTime
          );
        }
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/Workout/WorkoutCaloriesBurnt.js